

import React from 'react';
import { connect } from 'react-redux';
import LoadingAnimation from '../../Utils/loadingAnimation.js';
import { setCache,setRegisterDetails } from '../../General/Actions.js';
import Network from '../../Utils/network.js';
import Swal from 'sweetalert2';

class RechargeComponent extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isLoading: false,
            billingName: "",
            contactNumber: "",
            accountId:"",
            currentActiveSubMenu: "OVERVIEW",
            isFloatingSubMenuVisible: false,
            currentTab: "recharge"
        }
    }

    componentDidMount() {
        window.addEventListener('scroll', this.handleScroll);
        this.initializeQuerySubscriber(this.props.cache.querySubscriberResponse);

    }

   

    initializeQuerySubscriber(receivedResponse) {
        var params = [];
        try {
            params = receivedResponse.profile_info.basic_details;
        } catch (err) {
            params = [];
        }

        var maximumAmountConfig = 0;
        if(this.props.configurationValues && this.props.configurationValues.maxRechargeAmount && this.props.configurationValues.maxRechargeAmount > 0){
            maximumAmountConfig = this.props.configurationValues.maxRechargeAmount;
        }

        var firstName = "";
        var lastName = "";
        var finalContactNumber = "";
        for (var i = 0; i < params.length; i++) {
            if (params[i].id  === "first_name") {
                firstName = params[i].value;
            }
            if (params[i].id  === "last_name") {
                lastName = params[i].value;
            }
            if (params[i].id  === "contact_number_1") {
                finalContactNumber = params[i].value;
            }
        }
        this.setState({
            billingName: firstName+" "+lastName,
            contactNumber: finalContactNumber,
            maximumAmountConfig: maximumAmountConfig
        });
        try{
            var accountInfo = receivedResponse;
            var accountInfoParams =accountInfo.account_info.param;
            var finalAccountId = "";
            for (var j = 0; j < accountInfoParams.length; j++) {
                if (accountInfoParams[j].id  === "account_id") {
                    finalAccountId = accountInfoParams[j].value;
                }
            }
            this.setState({
                accountId: finalAccountId
            });
        } catch(err){

        }
    }

    handleScroll = (event) => {
        if (window.scrollY > 190) {
            this.setState({ isFloatingSubMenuVisible: true });
        } else {
            this.setState({ isFloatingSubMenuVisible: false });
        }
    }

    generalBtnClicked(type){
        this.setState({currentTab: type})
    }

    render() {
        return (
            <div className="col-md-12 animated fadeIn justify-content-center p-0 m-0">
                <div id="RechargeComponentContainer">
                    {this.state.isLoading  === true ? <LoadingAnimation isVisible={true} /> : this.renderRechargeContentPart()}
                </div>
            </div>
        );
    }

    renderRechargeContentPart() {
        return (<div className='col-md-12 m-0 p-0' style={{flex: 1}}>
            <div className='col-md-12 row justify-content-md-between justify-content-center m-0 pb-3' style={{flex:1}}>
                <div></div>
                <div className='d-flex'>
                    {/* <div className={this.state.currentTab === "bundles" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("bundles") }}>Bundles</div> */}
                    <div className={this.state.currentTab === "recharge" ? "redButtonContainer p-3 m-2" : "blueButtonContainer p-3 m-2"} onClick={(event) => { this.generalBtnClicked("recharge") }}>Recharge</div>
                </div>
                <div className='align-items-center'>
                    {/* <div className='brandColorButtonContainer p-2 px-4 m-1'> <div className='buttonTxtSmall'>Active</div> <div className='buttonTxtSmall'>Bundles</div>  </div> */}
                </div>
            </div>
            {this.state.currentTab === "bundles"? 
            <div className='cardOuterContainer col-md-12 row justify-content-between m-0' style={{ maxHeight:(window.innerHeight - 350 )+"px",overflow:"scroll"}}>
                {this.rechargeCard()}
                {this.rechargeCard()}
                {this.rechargeCard()}
                {this.rechargeCard()}
                {this.rechargeCard()}
                {this.rechargeCard()}
                {this.rechargeCard()}
            </div>
            : 
            <div className='col-md-12 row justify-content-center m-0'>
                {this.rechargePart()}
            </div>
            }
        </div>)
    }

    handleInputValueChange(event) {
        const validated = event.target.value.match(/^(\d*\.{0,1}\d{0,2}$)/)
        if(validated){
        const name = event.target.name;
        const value = event.target.value;
        this.state[name] = value;
        }
        this.setState({ dummy: "dummy" });
    };

    rechargeBtnClicked() {
        if(parseFloat(this.state.maximumAmountConfig) >= parseFloat(this.state.rechargeAmount)){
            this.setState({ isLoading: true })
            var dataToSend = {
                "amount": this.state.rechargeAmount,
                "rateCardId": "12345",
                "serviceId": this.props.cache.serviceInfo.serviceId
            }
            console.log("dataToSend>>>",dataToSend)
            Network.executeAxios("rechargeWithPlugNPay", "POST", dataToSend, (Response) => {
                this.setState({ isLoading: false, plugNPayInitialResponse: Response });
                window.location.replace("./plugNPay.html?responseData=" + encodeURIComponent(JSON.stringify(this.state.plugNPayInitialResponse)));
            });
        } else {Swal.fire(this.props.locales.maxRechargeAmountExceeds) }
    }


    rechargePart(){
        return(
            <div className='col-md-5 col-sm-12 '>
                <div className='rechargeCardDiv p-4 m-3 col-12'>
                <div className='d-flex justify-content-between align-items-center col-md-12 p-0'>
                <div className='col-md-8 mt-2'>
                    <select className="form-control input_data rechargeSelectBox"
                        value={this.state.rechargeAmount} name="rechargeAmount"
                        onChange={(event) => this.handleInputValueChange(event)}>
                        <option value="" >Select the Amount</option>
                        {this.props.configurationValues.rechargeSuggestionAmounts.map((item, key) => {
                            return (
                                <option key={key} value={item.amount}>{item.amount}</option>
                            )
                        })
                        }
                    </select>
                    <div className="errorDesc clearErrorp"></div>
                </div>
                <div className='rechargeCardActiveateBtn p-1 px-4 col-md-4' style={{height: 40}} onClick={() => { this.rechargeBtnClicked() }}>Pay</div>
                </div>
                <div className='col-md-12 mt-2'>
                    <input name="rechargeAmount" type="text"
                        className="form-control input_data rechargeTxtBox"
                        value={this.state.rechargeAmount} onChange={(event) => this.handleInputValueChange(event)}
                        style={{ height: 40, fontSize: 14 }}
                        placeholder="Enter the amount here"
                    />
                    <div className="errorDesc clearErrorp"></div>
                </div>
                </div>
            </div>
        )
    }

    rechargeCard(){
        return(
            <div className='col-md-4 col-sm-12 '>
                <div className='rechargeCardDiv p-4 m-md-3 my-3 col-12'>
                    <div className='d-flex justify-content-between'>
                        <div className='rechargeHead'>USA UK & Canada 30</div>
                        <div className='rechargeCardAmt'>$149.99</div>
                    </div>
                    <div className='d-flex justify-content-between'>
                        <div className='rechargeCardDesc col-md-7 p-0 m-0'>Get 400 minutes to the USA, UK, and Canada for only $150 ABST inc.</div>
                        <div className='rechargeCardActiveateBtn px-4 align-self-center'>Activate</div>
                    </div>
                    <div className='rechargeCardValidity'>Valid for 7 days</div>
                </div>
            </div>
        )
    }

}

const mapStateToProps = (state, ownProperties) => {
    return {
        locales: state.locales,
        cache: state.cache,
        userDetails: state.userDetails,
        configurationValues: state.configurationValues
    }
}

function mapDispatchToProps(dispatch) {
    return {
        setCache: function (key, payload) {
            dispatch(setCache(key, payload));
        },
        setRegisterDetails: function (key, payload) {
            dispatch(setRegisterDetails(key, payload));
        }
    }
}

const RechargeComponentContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(RechargeComponent)

export default RechargeComponentContainer;
